<template>
  <div>
    <base-nav
      class="fixed-top top-navbar d-sm-block d-none"
      type="primary"
      transparent
    >
      <div class="container">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item nav-link">
            <a href="/" class="nav-link" data-toggle="dropdown">
              Home
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/features" class="nav-link" data-toggle="dropdown">
              Features
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/pricing" class="nav-link" data-toggle="dropdown">
              Pricing
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/updates" class="nav-link" data-toggle="dropdown">
              Product updates
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/about" class="nav-link">
              About
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/contact" class="nav-link">
              Contact us
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="https://console.offthecouch.io/login" target="_blank" class="text-success nav-link">
              Login
            </a>
          </li>
<!--          <li class="nav-item nav-link d-none d-lg-block">-->
<!--            <base-button type="success" v-on:click="goToFreeTrial()">Free trial</base-button>-->
<!--          </li>-->
        </ul>
      </div>
    </base-nav>

    <base-nav
      class="fixed-top top-navbar d-sm-none d-block"
      type="dark"
    >
      <div class="ml-5 mr-5">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item nav-link">
            <a href="/" class="nav-link" data-toggle="dropdown">
              Home
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/features" class="nav-link" data-toggle="dropdown">
              Features
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/pricing" class="nav-link" data-toggle="dropdown">
              Pricing
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/updates" class="nav-link" data-toggle="dropdown">
              Product updates
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/about" class="nav-link">
              About
            </a>
          </li>
          <li class="nav-item nav-link">
            <a href="/contact" class="nav-link">
              Contact Us
            </a>
          </li>

          <li class="nav-item nav-link">
            <a href="https://console.offthecouch.io/login" target="_blank" class="text-success nav-link">
              Login
            </a>
          </li>
<!--          <li class="nav-item nav-link mb-4 mt-2">-->
<!--            <base-button type="success" v-on:click="goToFreeTrial()">Free trial</base-button>-->
<!--          </li>-->
        </ul>
      </div>
    </base-nav>
  </div>

</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
import {Dropdown, DropdownItem, DropdownMenu} from 'element-ui';


export default {
  components: {
    SidebarToggleButton,
    CollapseTransition,
    BaseNav,
    Modal,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    goToFreeTrial(){
      window.location = 'https://www.offthecouch.io/demo'
    },
  },
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
</style>
